import { render, staticRenderFns } from "./MyShopProducts.vue?vue&type=template&id=b4cbcc6c&scoped=true"
import script from "./MyShopProducts.vue?vue&type=script&lang=js"
export * from "./MyShopProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cbcc6c",
  null
  
)

export default component.exports